<template>
    <v-container fluid>
        <SToolbar>
            <KpIcon icon-cls="ic-20 ic-dashboard ic-col-grey" />
            <v-toolbar-title>{{ $t('dashboard') }}</v-toolbar-title>
        </SToolbar>

        <!-- top row, 3 cols with cards -->
        <v-row>
            <v-col cols="12" lg="4" class="d-flex">
                <GenericCard color="white" class="flex-grow-1">
                    <v-card-text>
                        <p class="card-title">
                            <KpIcon icon-cls="confetti" color="black" /> {{ $t('welcome') }}, {{ user.firstname }}
                        </p>
                        <p>
                            <span v-html="$t('welcome_card_staff_txt', { time: readableNow })"></span>
                        </p>
                    </v-card-text>
                </GenericCard>
            </v-col>
            <v-col cols="12" lg="4" class="d-flex">
                <NeuanmeldungenBenutzerCard class="flex-grow-1"></NeuanmeldungenBenutzerCard>
            </v-col>
            <v-col cols="12" lg="4" class="d-flex">
                <NeuanmeldungenAdressenCard class="flex-grow-1"></NeuanmeldungenAdressenCard>
            </v-col>
        </v-row>

        <!-- 2nd row: event table -->
        <v-row>
            <v-col cols="12">
                <EventList
                    session-key="event-home"
                    display-context="list"
                    height="calc(var(--usable-height-with-double-toolbar) - 200px)"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapState } from 'vuex';
import GenericCard from '@/components/home/GenericCard.vue';
import EventList from '@/components/event/List.vue';
import { globalParam } from '@/helpers/globals';
import dayjs from 'dayjs';
import NeuanmeldungenBenutzerCard from '@/components/home/NeuanmeldungenBenutzerCard.vue';
import NeuanmeldungenAdressenCard from '@/components/home/NeuanmeldungenAdressenCard.vue';

export default Vue.extend({
    name: 'HomeViewStaff',
    components: {
        EventList,
        GenericCard,
        NeuanmeldungenBenutzerCard,
        NeuanmeldungenAdressenCard,
    },
    computed: {
        ...mapState({
            user: (state: any) => state.user.record,
        }),
        readableNow() {
            // generate date in the format '15. Dezember 2009, 15:00':
            return dayjs().format('D. MMMM YYYY, HH:mm');
        },
    },
    methods: {
        globalParam,
    },
});
</script>

<style lang="scss" scoped>
.router-link {
    font-size: 14px;
}
</style>
